export type PointerLikeEvent = PointerEvent | TouchEvent | MouseEvent | { pageX?: number };

export const getPageX = (e: PointerLikeEvent): number | null => {
    if ('touches' in e && e.touches && e.touches[0]) {
        return e.touches[0].pageX;
    }
    if ('pageX' in e && typeof (e as any).pageX === 'number') {
        return (e as any).pageX as number;
    }
    return null;
};
